<span *ngIf="header" class="field-header">{{header}}</span> 
<mat-form-field class="form-control" style="width: 100%" [appearance]="appearance">
  <mat-label>{{ label }}</mat-label>
  <input
    type="text"
    [placeholder]="label"
    aria-label="Number"
    matInput
    [ngClass]="header ? 'mt-2' : ''"
    [formControl]="controlName"
    [matAutocomplete]="auto"
  />
  <mat-icon *ngIf="hasError()" matSuffix color="warn">info</mat-icon>
  <mat-icon *ngIf="!hasError() && !isValid()" color="primary" matSuffix>
    {{icon ? icon : 'search'}}
  </mat-icon>
  <mat-icon *ngIf="isValid()" matSuffix class="icon-success">check_circle</mat-icon>
  <mat-error *ngIf="hasError()">{{ getErrorMessage() }}</mat-error>
  <mat-autocomplete 
  #auto="matAutocomplete" 
  [displayWith]="displayFn"
  (optionSelected)="onSelect($event.option.value)"
  >
    <mat-option *ngFor="let elm of options | async" [value]="elm">
      {{ elm.name }}
    </mat-option>
  </mat-autocomplete>
</mat-form-field>
